import { Box, Flex, Typography } from "@aircall/tractor";

import {
  RatioBarProps,
  TalkRatioListItemProps,
} from "./TalkRatioListItem.decl";

import { SpeakerAvatar } from "@/components/SpeakerAvatar/SpeakerAvatar";
import { useSpeakerColor } from "@/hooks/useHasReadLinePermission/useHasReadLinePermission";

function RatioBar({ ratio, color }: RatioBarProps) {
  return (
    <Flex gap="xxs" w="100%" h="12px" alignItems="center">
      <Box
        px="xxxs"
        w={`${ratio}%`}
        backgroundColor={color}
        borderRadius="4px"
        minWidth="10px"
        h="100%"
      />
      <Typography
        variant="supportingMediumS"
        color="text-placeholder"
      >{`${ratio}%`}</Typography>
    </Flex>
  );
}

export function TalkRatioListItem({ ratio, channel }: TalkRatioListItemProps) {
  const color = useSpeakerColor(channel);

  return (
    <Flex gap="xxs" alignItems="center">
      <SpeakerAvatar channel={channel} />
      <RatioBar color={color} ratio={ratio} />
    </Flex>
  );
}
